import React from 'react';
import { Controller } from 'react-hook-form';
import { Slider } from '@ui/atoms/design-system/slider';

import { fdReturnsCalculator } from '@components/Products/FixedDeposits/utils/helper';
import useFDCalculator from '@components/Products/FixedDeposits/containers/useFDCalculator';
import FDChart from '@components/Products/FixedDeposits/components/Calculator/FDChart';
import { cn } from '@ui/helpers/utils';

const FdCalculatorView = () => {
    const { states, callbacks } = useFDCalculator();
    return (
        <div className="flex flex-col w-full gap-12 md:gap-6 md:flex-row md:justify-between max-w-[415px] mx-auto md:max-w-none">
            <InvestmentControls callbacks={callbacks} />
            <FDChart states={states} />
        </div>
    );
};

const InvestmentControls = ({ callbacks }) => {
    return (
        <div className="flex flex-col flex-1 gap-8 md:gap-12 max-w-[415px] mx-auto w-full">
            {fdReturnsCalculator.inputs.map((input) => {
                return (
                    <InvestmentInput
                        key={input.label}
                        input={input}
                        callbacks={callbacks}
                    />
                );
            })}
        </div>
    );
};

const InvestmentInput = ({ input, callbacks }) => {
    const { control, handleInputChange, handleBlur } = callbacks;

    return (
        <div className="flex flex-col w-full gap-4 md:gap-6">
            <div className="flex items-center justify-between w-full h-12">
                <label className="text-gray-700 p4-medium">{input.label}</label>
                <div className="flex items-center px-4 py-[12.5px] border-1.5 rounded-lg focus-within:border-primary-400 max-w-[124px] md:max-w-[160px] w-full">
                    {input.prefix && (
                        <span className="text-primary-400 p5-medium">
                            {input.prefix}
                        </span>
                    )}
                    <Controller
                        name={input.id}
                        control={control}
                        render={({ field }) => (
                            <input
                                type="text"
                                className={cn(
                                    'w-full p-0 text-lg font-medium text-right text-black bg-transparent border-none outline-none focus:border-none focus:ring-0 p5-medium',
                                    {
                                        'ml-2': input.prefix,
                                        'mr-2': input.suffix,
                                    }
                                )}
                                value={
                                    input.id === 'investmentAmount'
                                        ? field.value !== ''
                                            ? Number(
                                                  field.value
                                              ).toLocaleString('en-IN')
                                            : ''
                                        : field.value
                                }
                                onChange={(e) =>
                                    handleInputChange(
                                        input,
                                        e.target.value,
                                        field
                                    )
                                }
                                onBlur={(e) =>
                                    handleBlur(input, e.target.value, field)
                                }
                            />
                        )}
                    />
                    {input.suffix && (
                        <span className="text-primary-400 p5-medium">
                            {input.suffix}
                        </span>
                    )}
                </div>
            </div>
            <Controller
                name={input.id}
                control={control}
                render={({ field }) => {
                    return (
                        <Slider
                            min={input.min}
                            max={input.max}
                            step={input.step}
                            value={[parseFloat(field.value) || input.min]}
                            onValueChange={(value) => field.onChange(value[0])}
                            className="relative flex items-center w-full h-6"
                        />
                    );
                }}
            />
        </div>
    );
};

export default FdCalculatorView;
